(function(Carousel) {
  const $body = document.querySelector('body');
  const $page = document.querySelector('.page-container');
  const $header = document.querySelector('header');
  const $breadcrumbs = document.querySelectorAll('.js-nav-breadcrumb');

  const helpers = function() {
    const sleep = function(ms) { return new Promise(res => setTimeout(res, ms)); };

    const trackCustomGAEvent = function(event) {
      if (!event || !window.dataLayer) { return; }

      window.dataLayer.push(event);
    };

    return {
      sleep,
      trackCustomGAEvent,
    };
  }();

  const initMobileNavCarousels = function() {
    const $scrollableContainers = $header.querySelectorAll('.js-mobile-nav-carousel');
    if (!$scrollableContainers.length) { return; }

    $scrollableContainers.forEach(function($scrollableContainer) {
      let scrollerHasPeeked = false;

      const mobileScroller = new Carousel($scrollableContainer, {
        loop: false,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        mousewheel: {
          forceToAxis: true,
        },
        slidesPerView: 'auto',
        slidesOffsetAfter: 16,
        slidesOffsetBefore: 16,
        spaceBetween: 8,
        padding: 8,
      });

      const setupPeekEffect = function() {
        if(!scrollerHasPeeked) {
          // setup peek animation when visible
          const scrollerObserver = new IntersectionObserver(async (entries) => {
            for (let entry of entries) {
              if (entry.isIntersecting) {
                const scrollerEl = entry.target;

                await helpers.sleep(200);
                mobileScroller.slideTo(1, 280);
                await helpers.sleep(600);
                mobileScroller.slideTo(0, 280);

                scrollerObserver.unobserve(scrollerEl);
              }
            }
          }, { threshold: 0.95 });

          scrollerObserver.observe($scrollableContainer);

          scrollerHasPeeked = true;
        }
      };

      document.addEventListener('mobile-nav:opened', setupPeekEffect);
    });
  };

  const initMobileNavDropDowns = function() {
    const $mobileNavDropdowns = $header.querySelectorAll('.js-mobile-nav-dropdown');
    if (!$mobileNavDropdowns.length) { return; }

    let $currentOpenDropdown;
    let init = true;

    const setupDropdownHeights = function() {
      if ($mobileNavDropdowns.length) {
        $mobileNavDropdowns.forEach(function($dropdown) {
          const $dropdownContent = $dropdown.querySelector('.js-mobile-nav-dropdown-content');

          // remove collapsed styles
          $dropdownContent.classList.remove('loaded');
          $dropdownContent.style.setProperty('--max-inner-height', '');

          // setup real height
          const contentHeight = $dropdownContent.offsetHeight;
          $dropdownContent.style.setProperty('--max-inner-height', `${contentHeight}px`);
          $dropdownContent.classList.add('loaded');
        });
      }
    };

    const toggleDropdown = async function(e) {
      const $dropdownButton = e.currentTarget;
      const clickedDropdownIsOpen = $dropdownButton.classList.contains('expanded');

      const openDropdown = function() {
        const $dropdown = $dropdownButton.parentElement;
        const $dropdownContent = $dropdownButton.nextElementSibling;

        $dropdown.classList.add('expanded');
        $dropdownContent.classList.add('visible');
        $dropdownButton.classList.add('expanded');

        $currentOpenDropdown = $dropdownButton;

        if (!init) {
          $dropdownButton.scrollIntoView({ block: 'start', behavior: 'smooth' });
        } else {
          init = false;
        }

        // track dropdown opened
        helpers.trackCustomGAEvent({
          'event': 'dl_nav_dropdown_expanded',
          'gtm.element': $dropdownButton,
        });
      };

      const closeDropdown = function() {
        const $dropdown = $currentOpenDropdown.parentElement;
        const $dropdownContent = $currentOpenDropdown.nextElementSibling;

        $dropdown.classList.remove('expanded');
        $dropdownContent.classList.remove('visible');
        $currentOpenDropdown.classList.remove('expanded');

        $currentOpenDropdown = null;
      };

      if ($currentOpenDropdown && ($currentOpenDropdown !== $dropdownButton)) {
        closeDropdown();
        await helpers.sleep(400);
      }

      if (!clickedDropdownIsOpen) {
        openDropdown();
      } else {
        closeDropdown();
      }
    };

    const dropdownResize = new ResizeObserver(setupDropdownHeights);
    dropdownResize.observe($header, { box: 'border-box' });

    $mobileNavDropdowns.forEach(function($dropdown) {
      const $dropdownBtn = $dropdown.querySelector('.js-mobile-nav-dropdown-btn');
      $dropdownBtn.addEventListener('click', toggleDropdown);
    });

    document.addEventListener('mobile-nav:closed', function() {
      if ($currentOpenDropdown) {
        $currentOpenDropdown.click();
      }
    });
  };

  const initMobileNavStates = function() {
    const $hamburger = $header.querySelector('button.hamburger');
    const $closeBurger = $header.querySelector('.close-nav');
    const $mobileNav = $header.querySelector('.mobile-nav');
    const $mobileLinksContainer = $header.querySelector('.mobile-nav__links');
    const $mobileBG = $header.querySelector('.mobile-bg');

    // events
    const announcementHidden = new Event('announcement:hidden');
    const announcementVisible = new Event('announcement:visible');
    const headerResized = new Event('header:resized');
    const mobileNavOpened = new Event('mobile-nav:opened');
    const mobileNavClosed = new Event('mobile-nav:closed');

    let _windowWidth = window.outerWidth;
    let _windowPosition = 0;
    let _navOpened = false;
    let _userScrolled = false;
    let _initialized = true;

    const openMobileNav = function() {
      _windowPosition = window.scrollY;

      $body.classList.add('locked');
      $header.classList.add('header--mobile-open');

      if (!_userScrolled) {
        $page.classList.add('page-container--mobile-open');
      }

      $mobileNav.classList.add('open');
      $mobileBG.classList.add('visible');

      $body.style.top = `-${_windowPosition}px`;

      // allows triggering popstate to close navs with back button.
      history.pushState(null, null, window.location.pathname);

      // dispatch global nav close event
      document.dispatchEvent(mobileNavOpened);

      _navOpened = true;
    };

    const closeMobileNav = async function() {
      $body.style.top = '';
      $body.classList.remove('locked');
      $mobileNav.classList.remove('open');
      $mobileBG.classList.remove('visible');
      $header.classList.remove('header--mobile-open');
      $page.classList.remove('page-container--mobile-open');

      // reset the window y position to where it was
      // when the menu was opened
      window.scroll(0, _windowPosition);

      // also reset the links container scroll position
      await helpers.sleep(240);
      $mobileLinksContainer.scroll(0, 0);

      // dispatch global nav close event
      document.dispatchEvent(mobileNavClosed);

      _navOpened = false;
    };

    const handleUserScroll = function() {
      const scrollTop = window.scrollY;

      if (scrollTop > 8 && !_userScrolled && !$body.classList.contains('locked')) {
        document.dispatchEvent(announcementHidden);
        $header.classList.add('header--scrolled');
        $mobileNav.classList.add('mobile-nav--scrolled');
        document.dispatchEvent(headerResized);

        _userScrolled = true;
      }

      if(scrollTop <= 8 && _userScrolled && !$body.classList.contains('locked')) {
        document.dispatchEvent(announcementVisible);
        $header.classList.remove('header--scrolled');
        $mobileNav.classList.remove('mobile-nav--scrolled');

        _userScrolled = false;
      }
    };

    const navResize = new ResizeObserver(function() {
      if (window.outerWidth ===_windowWidth && _initialized) { return; }

      // close mobile menu if open and resize is triggered by new window width
      if (window.outerWidth !== _windowWidth && _navOpened) {
        closeMobileNav();
      }

      _windowWidth = window.outerWidth;

      if(!_initialized) {
        _initialized = true;
      }
    });
    navResize.observe($header, { box: 'border-box' });

    $hamburger.addEventListener('click', openMobileNav);
    $closeBurger.addEventListener('click', closeMobileNav);
    $mobileBG.addEventListener('click', closeMobileNav);
    window.addEventListener('scroll', handleUserScroll);
    handleUserScroll();

    // Close mobile nav with Escape key if open
    document.addEventListener('keydown', (e) => {
      if (e.key == 'Escape') {
        if (_navOpened) {
          closeMobileNav();
        }
      }
    });

    // Use browser back button to close nav
    document.addEventListener('popstate:nav', () => {
      if (_navOpened) {
        closeMobileNav();
      }
    });

    return {
      openMobileNav,
    };
  };

  const initDesktopShopDropdown = function() {
    const $shopDropdownButton = $header.querySelector('.js-shop-dropdown');
    if (!$shopDropdownButton) { return; }

    // find all child links related to dropdown
    const $dropdownMenu = $shopDropdownButton.nextElementSibling;
    const $dropdownMenuLinks = $dropdownMenu.querySelectorAll('a');
    const $dropdownNavigationList = $shopDropdownButton.closest('ul').children;
    const $allOtherNavItems = [...$dropdownNavigationList].reduce(($items, $li) => {
      const $link = $li.querySelector('.menu-icon, .menu-link');
      if ($link && $link !== $shopDropdownButton && !$link.hasAttribute('hidden')) {
        $items.push($link);
      };

      return $items;
    }, []);

    const $announcementBar = document.querySelector('.js-announcement-bar');
    const $heroLogo = $header.querySelector('.header__logo a');

    // dropdown state
    let dropdownIsOpen = false;

    const openDropdown = function() {
      $shopDropdownButton.setAttribute('aria-expanded', 'true');
      $header.classList.add('dropdown-active');
      $dropdownMenu.classList.add('active');

      document.addEventListener('scroll', closeDropdown);
      document.addEventListener('keydown', closeDropdown);
      $header.addEventListener('keydown', trackDropdownKeyboardTaps);

      dropdownIsOpen = true;

      // track dropdown opened
      helpers.trackCustomGAEvent({
        'event': 'dl_nav_dropdown_expanded',
        'gtm.element': $shopDropdownButton,
      });
    };

    const closeDropdown = function(e) {
      if (e instanceof KeyboardEvent && e.key !== 'Escape') { return; }
      if ($shopDropdownButton.getAttribute('aria-expanded' === 'false')) { return; }

      $shopDropdownButton.setAttribute('aria-expanded', 'false');
      $header.classList.remove('dropdown-active');
      $dropdownMenu.classList.remove('active');

      document.removeEventListener('scroll', closeDropdown);
      document.removeEventListener('keydown', closeDropdown);
      $header.removeEventListener('keydown', trackDropdownKeyboardTaps);

      dropdownIsOpen = false;
    };

    const trackDropdownKeyboardTaps = function(e) {
      const $this = e.target;
      const thisIsDropdownButton = $this === $shopDropdownButton;
      const shiftPressed = e.shiftKey;

      // if dropdown is open and user is tabbing through
      if (dropdownIsOpen && e.key === 'Tab') {
        if (!shiftPressed && thisIsDropdownButton) {
          e.preventDefault();

          $dropdownMenuLinks[0].focus();
        }

        if (shiftPressed && $this === $dropdownMenuLinks[0]) {
          e.preventDefault();

          $shopDropdownButton.focus();
        }
      }
    };

    /* Hover States */
    $allOtherNavItems.forEach(function($otherNavItem) {
      $otherNavItem.addEventListener('mouseenter', closeDropdown);
    });

    $dropdownMenu.addEventListener('mouseleave', closeDropdown);

    $header.addEventListener('mouseleave', closeDropdown);
    $heroLogo.addEventListener('mouseenter', closeDropdown);

    if ($announcementBar) {
      $announcementBar.addEventListener('mouseenter', closeDropdown);
    }

    $shopDropdownButton.addEventListener('mouseenter', openDropdown);

    /* Keyboard accesibility */
    $heroLogo.addEventListener('focus', closeDropdown);
    $allOtherNavItems[0].addEventListener('focus', closeDropdown);

    $shopDropdownButton.addEventListener('click', function() {
      if (dropdownIsOpen) {
        closeDropdown()
      } else {
        openDropdown();
      }
    });
  };

  const initBreadCrumbNavOpener = function() {
    if (!$breadcrumbs.length) { return; }

    // mobile
    const $mobileHamburger = $header.querySelector('button.hamburger');

    $breadcrumbs.forEach(function($breadcrumb) {
      $breadcrumb.addEventListener('click', async function(e) {
        const $this = e.currentTarget;
        const view = $this.dataset.view;
        const category = $this.dataset.category;

        if (view === 'm') {
          const $shopDropdownButton = $header.querySelector(`#m_cat_${category}`);

          $mobileHamburger.click();
          await helpers.sleep(360);
          $shopDropdownButton.click();
        } else {
          const $shopDropdownButton = $header.querySelector(`#d_cat_${category}`);

          $shopDropdownButton.click();
        }
      });
    });
  };

  initMobileNavStates();
  initMobileNavCarousels();
  initMobileNavDropDowns();
  initDesktopShopDropdown();
  initBreadCrumbNavOpener();
})(window.HeroSwiper);
